/**
 * This extracts the partner from a url. It defaults to "my" if the partner is not found.
 * @param url the url of the page to extract partner from
 * @returns the partner slug from the domain
 */
export const getPartner = (url: URL) => {
  const domainParts = url.hostname.split(".");
  if (domainParts.length > 3) {
    return domainParts[0];
  } else throw new Error("Partner not found");
};

const urlToString = (url: string | URL) => {
  return typeof url === "string" ? url : url.pathname;
};

export const getUrlWithoutPartner = (url: string | URL) => {
  const urlStr = urlToString(url).split(".");
  urlStr.shift();
  return urlStr.join(".");
};
